export default {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-924647064";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-924647064");
  },
  paso1() {
    window.gtag("event", "conversion", {
      send_to: "AW-924647064/DIkmCO_y6uUZEJj987gD"
    });
  },
  paso2() {
    window.gtag("event", "conversion", {
      send_to: "AW-924647064/b3_SCMGw7OUZEJj987gD"
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      send_to: "AW-924647064/K7ywCJCN4OUZEJj987gD"
    });
  }
};
